const tableTitle = {
  placeholder: 'Search'
};

export default tableTitle;
